import { OP, STATUS } from "../../constant";

const INITIAL_STATE = {
  // -------- egent initial ------- //
  agentListStatus: STATUS.DEFAULT,
  agentListResult: null,
  agentListErrormessage: "",

  addAgentStatus: STATUS.DEFAULT,
  addAgentResult: null,
  addAgentErrorMessage: "",

  viewAgentStatus: STATUS.DEFAULT,
  viewAgentResult: null,
  viewAgentErrorMessage: "",

  editAgentStatus: STATUS.DEFAULT,
  editAgentResult: null,
  editAgentErrorMessage: "",

  activateAgentStatus: STATUS.DEFAULT,
  activateAgentResult: null,
  activateAgentErrorMessage: "",

  deactivateAgentStatus: STATUS.DEFAULT,
  deactivateAgentResult: null,
  deactivateAgentErrorMessage: "",

  approveAgentStatus: STATUS.DEFAULT,
  approveAgentResult: null,
  approveAgentErrorMessage: "",

  rejectAgentStatus: STATUS.DEFAULT,
  rejectAgentResult: null,
  rejectAgentErrorMessage: "",

  getAgentDetailsStatus: STATUS.DEFAULT,
  getAgentDetailsResult: null,
  getAgentDetailsErrorMessage: "",

  agentCommissionSummaryStatus: STATUS.DEFAULT,
  agentCommissionSummaryResult: null,
  agentCommissionSummaryErrorMessage: "",

  agentCommissionsStatus: STATUS.DEFAULT,
  agentCommissionsResult: null,
  agentCommissionsErrorMessage: "",

  agentCommissionsByDateStatus: STATUS.DEFAULT,
  agentCommissionsByDateResult: null,
  agentCommissionsByDateErrorMessage: "",
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    // *-------- > agent list reducers
    case OP.AGENT_LIST_LOADING:
      return {
        ...state,
        agentListStatus: STATUS.LOADING,
      };
    case OP.AGENT_LIST_SUCCESS:
      return {
        ...state,
        agentListStatus: STATUS.SUCCESS,
        agentListResult: payload,
        agentListErrorMessage: "",
      };
    case OP.AGENT_LIST_FAILURE:
      return {
        ...state,
        agentListStatus: STATUS.ERROR,
        agentListResult: null,
        agentListErrorMessage: payload,
      };
    case OP.AGENT_LIST_RESET:
      return {
        ...state,
        agentListStatus: STATUS.DEFAULT,
        agentListResult: null,
        agentListErrorMessage: "",
      };

    // *-------- > add agent reducers
    case OP.ADD_AGENT_LOADING:
      return {
        ...state,
        addAgentStatus: STATUS.LOADING,
      };
    case OP.ADD_AGENT_SUCCESS:
      return {
        ...state,
        addAgentStatus: STATUS.SUCCESS,
        addAgentResult: payload,
        addAgentErrorMessage: "",
      };
    case OP.ADD_AGENT_FAILURE:
      return {
        ...state,
        addAgentStatus: STATUS.ERROR,
        addAgentResult: null,
        addAgentErrorMessage: payload,
      };
    case OP.ADD_AGENT_RESET:
      return {
        ...state,
        addAgentStatus: STATUS.DEFAULT,
        addAgentResult: null,
        addAgentErrorMessage: "",
      };

    // *-------- > view agent reducers
    case OP.VIEW_AGENT_LOADING:
      return {
        ...state,
        viewAgentStatus: STATUS.LOADING,
      };
    case OP.VIEW_AGENT_SUCCESS:
      return {
        ...state,
        viewAgentStatus: STATUS.SUCCESS,
        viewAgentResult: payload,
        viewAgentErrorMessage: "",
      };
    case OP.VIEW_AGENT_FAILURE:
      return {
        ...state,
        viewAgentStatus: STATUS.ERROR,
        viewAgentResult: null,
        viewAgentErrorMessage: payload,
      };
    case OP.VIEW_AGENT_RESET:
      return {
        ...state,
        viewAgentStatus: STATUS.DEFAULT,
        viewAgentResult: null,
        viewAgentErrorMessage: "",
      };

    // *-------- > edit agent reducers
    case OP.EDIT_AGENT_LOADING:
      return {
        ...state,
        editAgentStatus: STATUS.LOADING,
      };
    case OP.EDIT_AGENT_SUCCESS:
      return {
        ...state,
        editAgentStatus: STATUS.SUCCESS,
        editAgentResult: payload,
        editAgentErrorMessage: "",
      };
    case OP.EDIT_AGENT_FAILURE:
      return {
        ...state,
        editAgentStatus: STATUS.ERROR,
        editAgentResult: null,
        editAgentErrorMessage: payload,
      };
    case OP.EDIT_AGENT_RESET:
      return {
        ...state,
        editAgentStatus: STATUS.DEFAULT,
        editAgentResult: null,
        editAgentErrorMessage: "",
      };

    // *-------- > activate agent reducers
    case OP.ACTIVATE_AGENT_LOADING:
      return {
        ...state,
        activateAgentStatus: STATUS.LOADING,
      };
    case OP.ACTIVATE_AGENT_SUCCESS:
      return {
        ...state,
        activateAgentStatus: STATUS.SUCCESS,
        activateAgentResult: payload,
        activateAgentErrorMessage: "",
      };
    case OP.ACTIVATE_AGENT_FAILURE:
      return {
        ...state,
        activateAgentStatus: STATUS.ERROR,
        activateAgentResult: null,
        activateAgentErrorMessage: payload,
      };
    case OP.ACTIVATE_AGENT_RESET:
      return {
        ...state,
        activateAgentStatus: STATUS.DEFAULT,
        activateAgentResult: null,
        activateAgentErrorMessage: "",
      };

    // *-------- > deactivate agent reducers
    case OP.DEACTIVATE_AGENT_LOADING:
      return {
        ...state,
        deactivateAgentStatus: STATUS.LOADING,
      };
    case OP.DEACTIVATE_AGENT_SUCCESS:
      return {
        ...state,
        deactivateAgentStatus: STATUS.SUCCESS,
        deactivateAgentResult: payload,
        deactivateAgentErrorMessage: "",
      };
    case OP.DEACTIVATE_AGENT_FAILURE:
      return {
        ...state,
        deactivateAgentStatus: STATUS.ERROR,
        deactivateAgentResult: null,
        deactivateAgentErrorMessage: payload,
      };
    case OP.DEACTIVATE_AGENT_RESET:
      return {
        ...state,
        deactivateAgentStatus: STATUS.DEFAULT,
        deactivateAgentResult: null,
        deactivateAgentErrorMessage: "",
      };

    // *-------- >approve agent reducers
    case OP.APPROVE_AGENT_LOADING:
      return {
        ...state,
        approveAgentStatus: STATUS.LOADING,
      };
    case OP.APPROVE_AGENT_SUCCESS:
      return {
        ...state,
        approveAgentStatus: STATUS.SUCCESS,
        approveAgentResult: payload,
        approveAgentErrorMessage: "",
      };
    case OP.APPROVE_AGENT_FAILURE:
      return {
        ...state,
        approveAgentStatus: STATUS.ERROR,
        approveAgentResult: null,
        approveAgentErrorMessage: payload,
      };
    case OP.APPROVE_AGENT_RESET:
      return {
        ...state,
        approveAgentStatus: STATUS.DEFAULT,
        approveAgentResult: null,
        approveAgentErrorMessage: "",
      };

    // *-------- >reject agent reducers
    case OP.REJECT_AGENT_LOADING:
      return {
        ...state,
        rejectAgentStatus: STATUS.LOADING,
      };
    case OP.REJECT_AGENT_SUCCESS:
      return {
        ...state,
        rejectAgentStatus: STATUS.SUCCESS,
        rejectAgentResult: payload,
        rejectAgentErrorMessage: "",
      };
    case OP.REJECT_AGENT_FAILURE:
      return {
        ...state,
        rejectAgentStatus: STATUS.ERROR,
        rejectAgentResult: null,
        rejectAgentErrorMessage: payload,
      };
    case OP.REJECT_AGENT_RESET:
      return {
        ...state,
        rejectAgentStatus: STATUS.DEFAULT,
        rejectAgentResult: null,
        rejectAgentErrorMessage: "",
      };

    // *-------- >get agent details reducers
    case OP.GET_AGENT_DETAILS_LOADING:
      return {
        ...state,
        getAgentDetailsStatus: STATUS.LOADING,
      };
    case OP.GET_AGENT_DETAILS_SUCCESS:
      return {
        ...state,
        getAgentDetailsStatus: STATUS.SUCCESS,
        getAgentDetailsResult: payload,
        getAgentDetailsErrorMessage: "",
      };
    case OP.GET_AGENT_DETAILS_FAILURE:
      return {
        ...state,
        getAgentDetailsStatus: STATUS.ERROR,
        getAgentDetailsResult: null,
        getAgentDetailsErrorMessage: payload,
      };
    case OP.GET_AGENT_DETAILS_RESET:
      return {
        ...state,
        getAgentDetailsStatus: STATUS.DEFAULT,
        getAgentDetailsResult: null,
        getAgentDetailsErrorMessage: "",
      };

    // *-------- >agent commission summary reducers
    case OP.AGENT_COMMISSION_SUMMARY_LOADING:
      return {
        ...state,
        agentCommissionSummaryStatus: STATUS.LOADING,
      };
    case OP.AGENT_COMMISSION_SUMMARY_SUCCESS:
      return {
        ...state,
        agentCommissionSummaryStatus: STATUS.SUCCESS,
        agentCommissionSummaryResult: payload,
        agentCommissionSummaryErrorMessage: "",
      };
    case OP.AGENT_COMMISSION_SUMMARY_FAILURE:
      return {
        ...state,
        agentCommissionSummaryStatus: STATUS.ERROR,
        agentCommissionSummaryResult: null,
        agentCommissionSummaryErrorMessage: payload,
      };
    case OP.AGENT_COMMISSION_SUMMARY_RESET:
      return {
        ...state,
        agentCommissionSummaryStatus: STATUS.DEFAULT,
        agentCommissionSummaryResult: null,
        agentCommissionSummaryErrorMessage: "",
      };

    // *-------- >agent commissions list reducers
    case OP.AGENT_COMMISSIONS_LOADING:
      return {
        ...state,
        agentCommissionsStatus: STATUS.LOADING,
      };
    case OP.AGENT_COMMISSIONS_SUCCESS:
      return {
        ...state,
        agentCommissionsStatus: STATUS.SUCCESS,
        agentCommissionsResult: payload,
        agentCommissionsErrorMessage: "",
      };
    case OP.AGENT_COMMISSIONS_FAILURE:
      return {
        ...state,
        agentCommissionsStatus: STATUS.ERROR,
        agentCommissionsResult: null,
        agentCommissionsErrorMessage: payload,
      };
    case OP.AGENT_COMMISSIONS_RESET:
      return {
        ...state,
        agentCommissionsStatus: STATUS.DEFAULT,
        agentCommissionsResult: null,
        agentCommissionsErrorMessage: "",
      };

    // *-------- >agent commissions by date reducers
    case OP.AGENT_COMMISSIONS_BY_DATE_LOADING:
      return {
        ...state,
        agentCommissionsByDateStatus: STATUS.LOADING,
      };
    case OP.AGENT_COMMISSIONS_BY_DATE_SUCCESS:
      return {
        ...state,
        agentCommissionsByDateStatus: STATUS.SUCCESS,
        agentCommissionsByDateResult: payload,
        agentCommissionsByDateErrorMessage: "",
      };
    case OP.AGENT_COMMISSIONS_BY_DATE_FAILURE:
      return {
        ...state,
        agentCommissionsByDateStatus: STATUS.ERROR,
        agentCommissionsByDateResult: null,
        agentCommissionsByDateErrorMessage: payload,
      };
    case OP.AGENT_COMMISSIONS_BY_DATE_RESET:
      return {
        ...state,
        agentCommissionsByDateStatus: STATUS.DEFAULT,
        agentCommissionsByDateResult: null,
        agentCommissionsByDateErrorMessage: "",
      };

    default:
      return state;
  }
};
